export default __webpack_public_path__ + "images/3d9c854f4a73362d6035920bca1648f1.svg";